import React from 'react'
import styles from './FirstView.module.css'
import { FirstViewProps } from './types'

const IMAGES = {
    firstViewImg: '/pages/firstview_tiktok_smart_plus.jpg',
}

// /tiktok_smart_plus 専用のFV。DEV-3480でTikTokの審査対応（業務内容が不明瞭として差し戻し）
// のため旧FV(firstview-b36.png)から差し替えた。直下に企業ロゴ帯(CompanyLogoStrip)、
// LP下部に「求人数No.1 ※」の根拠となる調査注記(Annotation)が並ぶ前提の画像。
// AB判定は持たない（LPOを挟まない100%反映。settings.tsにもconfigを置いていない）。
export const FirstView = ({ dataViewLabel }: FirstViewProps) => {
    return (
        <section data-view-label={dataViewLabel}>
            <div className={styles.contentWrap}>
                <img
                    src={IMAGES.firstViewImg}
                    alt='今すぐ働ける飲食求人見つかります！ 飲食店正社員 求人数No.1 ※'
                    width={375}
                    height={235}
                />
            </div>
        </section>
    )
}
